import { NgModule } from "@angular/core";
import { BreadcrumbComponent } from './breadcrumb.component';
import { CommonModule } from "@angular/common";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    imports: [
        CommonModule,
        NgbTooltipModule
    ],
    declarations: [BreadcrumbComponent],
    exports: [BreadcrumbComponent],
    providers: [ ]
  })
  export class BreadcrumbModule { }